import { CollectionFlag, Prefix } from '@/types'
import { exists } from '@/api'

export interface BibliographySearchListDetail {
  prefix: Prefix
  id: string
  bibliographyId: number
  marcNo: string
  collectionFlag: CollectionFlag
  collectionNo: string
  shelfType: string
  callNo: string
  handlingType: string
  canLendHandlingType: boolean
  collectionStatus: string
  continuationStatusName: string
  displayMaterialFormatName: string
  shelfCount: number
  holdingCount: number
  orderCount: number
  reserveCount: number
}

export function BibliographySearchListDetailFromJSON(
  json: any
): BibliographySearchListDetail {
  return {
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    id: json.prefix + json.bibliography_id,
    bibliographyId: exists(json, 'bibliography_id') ? json.bibliography_id : 0,
    marcNo: exists(json, 'marc_no') ? json.marc_no : '',
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    shelfType: exists(json, 'shelf_type') ? json.shelf_type : '',
    callNo: exists(json, 'call_no') ? json.call_no : '',
    handlingType: exists(json, 'handling_type') ? json.handling_type : '',
    canLendHandlingType: exists(json, 'can_lend_handling_type')
      ? json.can_lend_handling_type
      : false,
    collectionStatus: exists(json, 'collection_status')
      ? json.collection_status
      : '',
    continuationStatusName: exists(json, 'continuation_status_name')
      ? json.continuation_status_name
      : '',
    displayMaterialFormatName: exists(json, 'display_material_format_name')
      ? json.display_material_format_name
      : '',
    shelfCount: exists(json, 'shelf_count') ? json.shelf_count : 0,
    holdingCount: exists(json, 'holding_count') ? json.holding_count : 0,
    orderCount: exists(json, 'order_count') ? json.order_count : 0,
    reserveCount: exists(json, 'reserve_count') ? json.reserve_count : 0
  }
}
